export default __webpack_public_path__ + "static/media/raptor-mobile.dcd33303.png";